/* global intlTelInputUtils */

import intlTelInput from 'intl-tel-input'
import 'intl-tel-input/build/js/utils'
import 'intl-tel-input/build/css/intlTelInput.css'

import { sendVerificationCode } from 'services/courier_signup'

export default () => {
  const store = Alpine.store('CourierSignup')

  return {
    phoneNumber: '',
    isValidNumber: false,
    errors: '',
    iti: null,
    isSubmitting: false,

    init () {
      document.addEventListener('DOMContentLoaded', () => {
        if (this.$refs.phone) {
          this.iti = intlTelInput(this.$refs.phone, {
            initialCountry: 'sa',
            separateDialCode: true,
            autoPlaceholder: 'aggressive',
            nationalMode: false,
            onlyCountries: store.allowedCountries
          })
        }
      })
    },

    formatAndValidateIntlTelInput () {
      const currentText = this.iti.getNumber(intlTelInputUtils.numberFormat.E164)
      if (typeof currentText === 'string') {
        this.iti.setNumber(currentText)
        store.phoneNumber = currentText
        this.isValidNumber = this.iti.isValidNumber()
      }
    },

    sendSignupCode () {
      this.isSubmitting = true
      this.spinner.toggle()
      store.countryCode = this.iti.getSelectedCountryData().iso2

      sendVerificationCode({
        phone: store.phoneNumber.substring(1),
        language: 'en'
      }, () => {
        this.errors = ''
        this.isSubmitting = false
        this.spinner.toggle()
        store.setActiveStage('verification-code')
      }, (data) => {
        this.spinner.toggle()
        this.isSubmitting = false
        this.errors = data.errors
      })
    }
  }
}
